<template>
    <table-layout title="مدیریت تخفیف ها">
        <template #buttons>
            <router-link :to="{ name: 'TrashOffer' }">
                <b-button pill variant="danger"> سطل زباله </b-button>
            </router-link>

            <router-link :to="{ name: 'CreateOffer' }">
                <b-button pill variant="purple" class="ml-1 mb-1"> تخفیف جدید </b-button>
            </router-link>
        </template>

        <template #table>
            <offer-items :items="offers"></offer-items>
        </template>

        <div class="row pt-3">
            <div class="mt-3 color">
                <pagination :meta="meta" :on-change-page="changePage" />
            </div>
        </div>

    </table-layout>            
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import TableLayout from '../../components/dashboard/TableLayout'
import Pagination from "../../components/dashboard/Pagination"
import OfferItems from "../../components/dashboard/Offer/Items"


export default {
    name: "Offer",
    components: {TableLayout, Pagination, OfferItems},

    data() {
        return {
        }
    },
    computed: {
        ...mapGetters({
            offers: "Offer/getOffers",
            meta: "Offer/getPaginationMeta",
            links: "Offer/getPaginationLinks",
        }),
    },
    methods: {
        ...mapActions({
            getOffers: "Offer/getOffers",
        }),
        changePage(page) {
            this.getOffers(page)
        },
    },
    mounted() {
        this.getOffers()
    },
}
</script>

<style scoped>

</style>